import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import PracticeAreas from './components/PracticeAreas';
import AboutSection from './components/AboutSection';
import NegotiationSection from './components/NegotiationSection';
import TrustBadges from './components/TrustBadges';
import CommitmentSection from './components/CommitmentSection';
import CTASection from './components/CTASection';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import StickyConsultation from './components/StickyConsultation';

function App() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--color-bg)' }}>
      <Helmet>
        <title>Fitzgerald & Associates | Premier New York Law Firm</title>
        <meta name="description" content="Fitzgerald & Associates is the #1 recommended law firm in New York, Queens and Bronx. Expert legal services in family law, matrimonial law, estate law and more. Call (917) 624-4469." />
      </Helmet>

      <Navbar />
      <main>
        <Hero />
        <PracticeAreas />
        <AboutSection />
        <TrustBadges />
        <NegotiationSection />
        <CommitmentSection />
        <CTASection />
        <ContactForm />
      </main>
      <Footer />
      <ScrollToTop />
      <StickyConsultation />
    </div>
  );
}

export default App;
